import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {withFirestore, firestoreConnect, isLoaded, isEmpty} from "react-redux-firebase";
import {connect} from "react-redux";
import {SUBSCRIBED} from "../../utils/subsciptionStatus";
import {Redirect} from "react-router-dom"

const withCompanyManagerHOC = (OriginalComponent) => {
    class WithCompanyManagerHOC extends Component {
        render() {
            if (isLoaded(this.props.profile) && ! isEmpty(this.props.profile)) {
                if(this.props.profile.role === 'company'){
                    return <OriginalComponent {...this.props}/>
                }
                return <Redirect to={'/profile'}/>
            } else {
                return <div>(company manager)Loading...</div>
            }
        }
    }


    return (WithCompanyManagerHOC)
}

export default withCompanyManagerHOC;